import { useParams } from 'react-router-dom'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import { useContext, useEffect, useState } from 'react'
import {
  DeviceConnectionContext,
  SET_SELECTED_DEVICE_CONNECTION_DATA,
  SET_SHOW_HIDE_DEVICE_CONNECTION_POPUP,
  UPDATE_CHANGE_DEVICE_CONNECTION_DATA,
} from '../context/context'
import SelectInput from '../../../common/SelectInput'
import { getRequest, postRequest, putRequest } from '../../../../services/base'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import { toTitleCase } from '../../../../utils/common'

const DeviceConnectionForm = ({ onDataSave }) => {
  const { vehicle } = useParams()
  const [state, dispatch] = useContext(DeviceConnectionContext)
  const [deviceOptions, setDeviceOptions] = useState([])
  const [toPinsOptions, setToPinsOptions] = useState([])
  const [fromPinsOptions, setFromPinsOptions] = useState([])
  const [aliasesOptions, setAliasesOptions] = useState([])
  const [signalOptions, setSignalOptions] = useState([])

  useEffect(() => {
    getAliasesOptions()
    getSignalList()
  }, [])

  const getAliasesOptions = async () => {
    let res = await getRequest(
      `/api/device_connection/aliases/?vehicle=${vehicle}`
    )
    setAliasesOptions(res.data)
  }

  const getSignalList = async () => {
    let res = await getRequest(
      `/api/device_connection/signal_options/?vehicle=${vehicle}`
    )
    setSignalOptions(res.data)
  }

  const getPins = async (connectorObj, type) => {
    let res = await getRequest(
      `/api/device_connection/pins/?vehicle=${vehicle}&alias=${connectorObj.label}&type=${type}`
    )
    if (type == 'from') {
      setFromPinsOptions(res.data)
    } else {
      setToPinsOptions(res.data)
    }
  }

  const closePopUp = () => {
    setFromPinsOptions([])
    setToPinsOptions([])
    dispatch({
      type: SET_SHOW_HIDE_DEVICE_CONNECTION_POPUP,
      data: false,
    })
  }

  const getDeviceOptions = async (search = '') => {
    let res = await getRequest(
      `/api/devices/?vehicle=${vehicle}&search=${search}`
    )
    setDeviceOptions(res.results)
  }

  const saveDeviceConnectionsData = async (e) => {
    const formData = new FormData(e.target)
    formData.append('vehicle', vehicle)
    formData.delete('pin_from')
    formData.delete('pin_to')

    formData.append('pin_from', state?.selectedObject?.pin_from)
    formData.append('pin_to', state?.selectedObject?.pin_to)
    formData.append('signal_name', state?.selectedObject?.signal_obj?.value)
    formData.append('signal', state?.selectedObject?.signal_obj?.label)

    if (state?.selectedObject?.id) {
      let res = await putRequest(
        `/api/device_connection/${state?.selectedObject?.id}/?vehicle=${vehicle}`,
        formData
      )
      if (res?.status) {
        onDataSave(res?.status, 'Data Successfully Saved')
        dispatch({
          type: UPDATE_CHANGE_DEVICE_CONNECTION_DATA,
          data: state?.selectedObject,
        })
        closePopUp()
      }
    } else {
      let res = await postRequest(`/api/device_connection/`, formData)
      if (res?.status) {
        onDataSave(res?.status, 'Data Successfully Saved')
        closePopUp()
      }
    }
  }

  return (
    <Modal
      onClose={() => {
        closePopUp()
      }}
      show={state?.showDeviceConnFormPopup}
    >
      <ModalHeader className={'text-white'}>Device Connections</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            saveDeviceConnectionsData(e)
          }}
        >
          <div className="flex">
            <div className="w-1/2">
              <input
                type="hidden"
                name="import_file"
                value={
                  state?.selectedObject?.import_file
                    ? state?.selectedObject?.import_file
                    : null
                }
              />
              <input
                type="hidden"
                name="device"
                value={
                  state?.selectedObject?.device_data?.id
                    ? state?.selectedObject?.device_data?.id
                    : null
                }
              />
              <SelectInput
                name="device_data"
                label="Device"
                options={deviceOptions}
                value={state.selectedObject?.device_data}
                onInputChange={(value) => {
                  if (value) {
                    getDeviceOptions(value)
                  }
                }}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_DEVICE_CONNECTION_DATA,
                    data: {
                      ...state?.selectedObject,
                      device_data: value,
                      device: value.id,
                    },
                  })
                }}
                onMenuOpen={() => {
                  if (deviceOptions?.length < 1) {
                    getDeviceOptions('')
                  }
                }}
                optionLabel={'name'}
                optionValue={'id'}
                isRequired={false}
              />
            </div>
            <div className="w-1/2">
              <SelectInput
                isMulti={false}
                value={
                  state?.selectedObject?.signal_obj?.label
                    ? state?.selectedObject?.signal_obj
                    : null
                }
                options={signalOptions}
                placeholder="Select Signal"
                className="w-1/2 cursor-pointer"
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_DEVICE_CONNECTION_DATA,
                    data: {
                      ...state?.selectedObject,
                      signal: value.value,
                      signal_obj: value,
                    },
                  })
                }}
                isClearable={true}
                name="signal_data"
                label={'Signal'}
              />
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2">
              <SelectInput
                name="from_aliases"
                label="From Aliases"
                value={state?.selectedObject?.from_alias}
                options={aliasesOptions}
                onChange={(value) => {
                  if (value?.label) {
                    dispatch({
                      type: SET_SELECTED_DEVICE_CONNECTION_DATA,
                      data: {
                        ...state?.selectedObject,
                        from_alias: value,
                        pin_from_obj: null,
                        pin_from: null,
                      },
                    })
                    getPins(value, 'from')
                  } else {
                    dispatch({
                      type: SET_SELECTED_DEVICE_CONNECTION_DATA,
                      data: {
                        ...state?.selectedObject,
                        pin_from_obj: null,
                        pin_from: null,
                        from_alias: null,
                      },
                    })
                    setToPinsOptions([])
                  }
                }}
                isRequired={true}
              />
            </div>
            <div
              className={`w-1/2 ${!state?.selectedObject?.from_alias?.label && 'disabled'}`}
            >
              <SelectInput
                name="pin_from"
                label="Pin From"
                options={fromPinsOptions}
                value={state.selectedObject?.pin_from_obj}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_DEVICE_CONNECTION_DATA,
                    data: {
                      ...state?.selectedObject,
                      pin_from_obj: value,
                      pin_from: value?.label
                        ? `${state?.selectedObject?.from_alias?.label}-${value?.label}`
                        : null,
                    },
                  })
                }}
                isRequired={true}
                onMenuOpen={() => {
                  if (
                    fromPinsOptions?.length < 1 &&
                    state?.selectedObject?.from_alias?.label
                  ) {
                    getPins(state?.selectedObject?.from_alias, 'from')
                  }
                }}
              />
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2">
              <SelectInput
                name="to_aliases"
                label="To Aliases"
                value={state?.selectedObject?.to_alias}
                options={aliasesOptions}
                onChange={(value) => {
                  if (value?.label) {
                    dispatch({
                      type: SET_SELECTED_DEVICE_CONNECTION_DATA,
                      data: {
                        ...state?.selectedObject,
                        to_alias: value,
                        pin_to_obj: null,
                        pin_to: null,
                      },
                    })
                    getPins(value, 'to')
                  } else {
                    dispatch({
                      type: SET_SELECTED_DEVICE_CONNECTION_DATA,
                      data: {
                        ...state?.selectedObject,
                        pin_to_obj: null,
                        pin_to: null,
                        to_alias: null,
                      },
                    })
                    setToPinsOptions([])
                  }
                }}
                isRequired={true}
              />
            </div>
            <div
              className={`w-1/2 ${!state?.selectedObject?.to_alias?.label && 'disabled'}`}
            >
              <SelectInput
                name="pin_to"
                label="Pin To"
                value={state.selectedObject?.pin_to_obj}
                options={toPinsOptions}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_DEVICE_CONNECTION_DATA,
                    data: {
                      ...state?.selectedObject,
                      pin_to_obj: value,
                      pin_to: value?.label
                        ? `${state?.selectedObject?.to_alias?.label}-${value.label}`
                        : null,
                    },
                  })
                }}
                isRequired={true}
                onMenuOpen={() => {
                  if (
                    toPinsOptions?.length < 1 &&
                    state?.selectedObject?.to_alias?.label
                  ) {
                    getPins(state?.selectedObject?.to_alias, 'to')
                  }
                }}
              />
            </div>
          </div>
          <div className="flex justify-end py-4">
            <div className="w-1/3 px-2 mt-5 mb-5">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 w-full justify-end pr-2`}
                onClick={(e) => {}}
                value={'text'}
                text={'Save Device Connections'}
              />
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default DeviceConnectionForm
